module.exports = __webpack_public_path__ + "img/a6-افقی.d4dc8a65.jpg";